import ScannerEvent from "@/ScannerEvents/ScannerEvent";

export default class ButtonEvent extends ScannerEvent {
    constructor(action, fallbackActionName) {
        super();

        this.action = action;
        this.fallbackActionName = fallbackActionName;
    }

    static MatchesType(type) {
        return type === "b";
    }

    static ParseData(jsonData) {
        return new ButtonEvent(jsonData.a, jsonData.fa);
    }
}
